module.exports = __webpack_public_path__ + "assets/img/skin_3.e9f9e2f4.jpg";